import React, { useState, useEffect, useCallback, useRef } from 'react';
import Axios from 'axios';
import LoadingModal from '../Layout/LoadingModal.js';
import ModalTableTextInput from '../Generic/ModalTableTextInput.js';
import ModalTableTextNumericInput from '../Generic/ModalTableTextNumericInput.js';
import ModalTableDateInput from '../Generic/ModalTableDateInput.js';
import ModalTableSelectInput from '../Generic/ModalTableSelectInput.js';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { useAlert } from 'react-alert';
import { confirmAlert } from 'react-confirm-alert';
import { availableStatusOptions } from '../Generic/Constants.js';
import Button from 'react-bootstrap/Button';
import dayjs from 'dayjs';

let CancelToken = Axios.CancelToken;
let source = CancelToken.source();

const rowTitles = ['Código Molde', 'Tipo Molde', 'Peso Molde', 'Area Molde', 'Volumen', 'Espesor Placa', 'Peso Placa', 'Fecha de Calibración', 'Estado', 'Editado', 'Por', '-'];
const compareKeys = ['code', 'moldType', 'moldWeight', 'moldArea', 'volume', 'plateThickness', 'plateWeight', 'calibDate', 'status'];
const availableMoldOptions = [{ label: 'Molde Grande', value: 'largeMold' }, { label: 'Molde Chico', value: 'smallMold' }];

const RdEq = () => {

  const alert = useAlert();

  const [loading, setLoading] = useState(false);
  const [oldData, setOldData] = useState([]);
  const [data, setData] = useState([]);

  const isFirstRender = useRef(true);
  const scrollEndRef = useRef();

  const GetData = useCallback(() => {

    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = {
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken: source.token
    };

    const url = '/api/equipment/rd';

    Axios.get(url, opts)
    .then((res) => {
      setLoading(false);
      setOldData(JSON.parse(JSON.stringify(res.data)));
      setData(JSON.parse(JSON.stringify(res.data)));
    })
    .catch((err) => {
      setLoading(false);
      if (Axios.isCancel(err)) {
        alert.show('Petición cancelada', {type: 'info'});
      } else if (!err.response) {
        console.log('Petición cancelada');
      } else if (err.response.status === 500) {
        alert.show('No se recibió respuesta del servidor', {type: 'error'})
      } else {
        alert.show(err.response.data.msg, {type: 'error'})
      }
    });
  }, [alert]);

  const HandleChange = (index, key, value) => {
    if (value !== data[index][key]) {
      let newData = [...data];
      newData[index][key] = value;
      setData(newData);
    }
  }

  const DeleteRecordStepOne = (index) => {
    if (!data[index]._id) {
      let newData = [...data];
      newData.splice(index, 1);
      setData(newData);
    } else {
      confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside: false,
        customUI: ({ onClose }) => {
          return (
            <div className="modal-delete-confirm-container">
              <h4>Está eliminando la información de un Equipo</h4>
              <p> {'¿Está seguro(a) de eliminar el equipo '}{<b>{data[index].code}</b>}{'?'} </p>
              <div className="d-flex mt-3">
                <Button className="flex-1 silver-black me-2" onClick={() => onClose()}> No, deseo salir </Button>
                <Button className="flex-1 lb-white" onClick={() => { onClose(); DeleteRecordStepTwo(index) }}> Si, deseo eliminar </Button>
              </div>
            </div>
          );
        }
      })
    }
  }

  const DeleteRecordStepTwo = (index) => {
    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = {
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken: source.token
    };

    const url = '/api/equipment/rd/delete';

    Axios.post(url, {id: data[index]._id}, opts)
    .then((res) => {
      setLoading(false);
      alert.show(res.data.msg, {type: 'success', timeout: 10000});
      GetData();
    })
    .catch((err) => {
      setLoading(false);
      if (Axios.isCancel(err)) {
        alert.show('Petición cancelada', {type: 'info'});
      } else if (!err.response) {
        console.log('Petición cancelada');
      } else if (err.response.status === 500) {
        alert.show('No se recibió respuesta del servidor', {type: 'error'})
      } else {
        alert.show(err.response.data.msg, {type: 'error'})
      }
    });
  }

  const AddRecord = () => {
    const newRecord = {
      code: 'MDR-MSTD-',
      moldType: 'largeMold',
      moldWeight: '',
      moldArea: '',
      volume: '',
      plateThickness: '',
      plateWeight: '',
      calibDate: '',
      status: 'activo'
    };
    let newState = [...data];
    newState.push(newRecord);
    setData(newState);
    scrollEndRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  const SaveDataStepOne = () => {
    if (data.length) {

      let foundErrs = [];
      for (let i = 0; i < data.length; i++) {
        if (!data[i].code) {
          foundErrs.push('Fila ' + (i+1) + ': El código del equipo es requerido');
        }
        if (data.some((item, itemIdx) => ((item.code === data[i].code) && (itemIdx !== i)))) {
          foundErrs.push('Fila ' + (i+1) + ': El código ' + data[i].code + ' ya existe');
        }
      }

      if (foundErrs.length) {
        let errsMsg =
        <>
          <span className="mb-2">Se encontraron los siguientes errores: </span>
          { foundErrs.map((item, itemIdx) => <span key={itemIdx}>{item}</span> )}
        </>
        alert.show(errsMsg, {type: 'info'})
      } else {
        let toSaveArr = [];
        data.forEach((item, itemIdx) => {
          if (oldData[itemIdx]) {
            if (compareKeys.some(itemKey => (String(item[itemKey]) !== String(oldData[itemIdx][itemKey])))) {
              toSaveArr.push(item);
            }
          } else {
            toSaveArr.push(item);
          }
        });
        if (toSaveArr.length) {
          SaveDataStepTwo(toSaveArr)
        } else {
          alert.show('No se encontraron modificaciones', {type: 'info'});
        }
      }
    } else {
      alert.show('No se realizaron modificaciones', {type: 'info'});
    }
  }

  const SaveDataStepTwo = (saveArr) => {
    confirmAlert({
      closeOnEscape: false,
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="modal-delete-confirm-container">
            <h4>Está modificando información de equipos</h4>
            <p>Se guardarán los cambios para los siguientes equipos: </p>
            <div className="d-flex flex-column overflow-auto" style={{maxHeight: '50vh'}}>
              {saveArr.map((item, itemIdx) =>  <span key={itemIdx}>{item.code}</span>)}
            </div>
            <div className="d-flex mt-3">
              <Button className="flex-1 silver-black me-2" onClick={() => onClose()}> No, deseo salir </Button>
              <Button className="flex-1 lb-white" onClick={() => { onClose(); SaveDataStepThree(saveArr) }}> Si, deseo guardar </Button>
            </div>
          </div>
        );
      }
    })
  }

  const SaveDataStepThree = (saveArr) => {

    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = {
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken: source.token
    };

    const url = '/api/equipment/rd/update';

    Axios.post(url, saveArr, opts)
    .then((res) => {
      setLoading(false);
      let queryResponse =
        <>
          <span className="mb-2">Los resultados de sus modificaciones son: </span>
          { res.data.map((item, itemIdx) => <span key={itemIdx}>{item}</span> )}
        </>
      alert.show(queryResponse, {type: 'success', timeout: 20000});
      GetData();
    })
    .catch((err) => {
      setLoading(false);
      if (Axios.isCancel(err)) {
        alert.show('Petición cancelada', {type: 'info'});
      } else if (!err.response) {
        console.log('Petición cancelada');
      } else if (err.response.status === 500) {
        alert.show('No se recibió respuesta del servidor', {type: 'error'})
      } else {
        alert.show(err.response.data.msg, {type: 'error'})
      }
    });
  }

  useEffect(() => {
    if (isFirstRender.current) {
      GetData();
    }
  }, [GetData]);

  useEffect(() => { isFirstRender.current = false }, []);

  return (
    <>
      <LoadingModal loading={loading}/>
      <div className="modal-table-outer-container">
        <div className="modal-table-row-inner-container">
          <div className="modal-table-sticky-header-container">
            <div className="modal-table-sticky-header">
              { rowTitles.map((item, itemIdx) => <div key={itemIdx} className="modal-table-row-container"> {item} </div> )}
            </div>
          </div>
          {
            data.length ?
              data.map((item, itemIdx) => {
                return (
                  <div key={itemIdx} className="modal-table-row-input-container">
                    { item._id ? <span className="modal-table-title"> {item.code || '-'} </span> :
                    <ModalTableTextInput stateIdx={itemIdx} stateKey={'code'} value={item.code} handleChange={HandleChange} /> }
                    <ModalTableSelectInput stateIdx={itemIdx} stateKey={'moldType'} options={availableMoldOptions} value={item.moldType} handleChange={HandleChange} />
                    <ModalTableTextNumericInput stateIdx={itemIdx} stateKey={'moldWeight'} value={item.moldWeight} handleChange={HandleChange} />
                    <ModalTableTextNumericInput stateIdx={itemIdx} stateKey={'moldArea'} value={item.moldArea} handleChange={HandleChange} />
                    <ModalTableTextNumericInput stateIdx={itemIdx} stateKey={'volume'} value={item.volume} handleChange={HandleChange} />
                    <ModalTableTextNumericInput stateIdx={itemIdx} stateKey={'plateThickness'} value={item.plateThickness} handleChange={HandleChange} />
                    <ModalTableTextNumericInput stateIdx={itemIdx} stateKey={'plateWeight'} value={item.plateWeight} handleChange={HandleChange} />
                    <ModalTableDateInput stateIdx={itemIdx} stateKey={'calibDate'} value={item.calibDate ? item.calibDate.split('T')[0] : item.calibDate} handleChange={HandleChange} />
                    <ModalTableSelectInput stateIdx={itemIdx} stateKey={'status'} options={availableStatusOptions} value={item.status} handleChange={HandleChange} />
                    <div className="modal-table-row-container">
                      <span className="modal-table-title" title={item.lastModified ? dayjs(item.lastModified).format('LLLL') : '-'}>
                        {item.lastModified ? (dayjs().to(dayjs(item.lastModified))) : '-'}
                      </span>
                    </div>
                    <div className="modal-table-row-container">
                      <span className="modal-table-title"> {item.lastModifiedUser || '-'} </span>
                    </div>
                    <div className="modal-table-row-container">
                      <Button className="d-flex p-1 rounded-circle bg-lb-white" disabled={loading} title="Eliminar" onClick={() => DeleteRecordStepOne(itemIdx)}>
                        <FaTrash color="white" className="icon-style"/>
                      </Button>
                    </div>
                  </div>
                )
              })
            :
              <span className="modal-table-loading-text"> No hay información para mostrar </span>
          }
          <div ref={scrollEndRef}></div>
        </div>
        <div className="d-flex justify-content-center align-items-center p-1">
          <Button className="d-flex p-2 rounded-circle bg-lb-white" disabled={loading} title="Nuevo Registro" onClick={() => AddRecord()}>
            <FaPlus color="white" size={15} className="icon-style"/>
          </Button>
        </div>
      </div>
      <div className="mt-1">
        <Button className="lb-white fs-7" disabled={loading} onClick={() => SaveDataStepOne()}>Guardar</Button>
      </div>
    </>
  )
}

export default RdEq;